export type OfferBuilderStepPath = '' | 'frequency' | 'rate' | 'preferred-upgrade' | 'review';

interface OfferBuilderStep {
  path: OfferBuilderStepPath;
  label: string;
  stepNumber: number;
}

const ALL_STEPS: OfferBuilderStep[] = [
  {
    path: '',
    label: 'builder.selectYourCustomers',
    stepNumber: 1,
  },
  {
    path: 'frequency',
    label: 'builder.selectYourFrequency',
    stepNumber: 2,
  },
  {
    path: 'rate',
    label: 'builder.selectYourRate',
    stepNumber: 3,
  },
  {
    path: 'preferred-upgrade',
    label: 'builder.preferredOfferOption',
    stepNumber: 4,
  },
  {
    path: 'review',
    label: 'builder.reviewYourOffer',
    stepNumber: 5,
  },
];

export const getOfferBuilderSteps = (includePreferred: boolean): OfferBuilderStep[] => {
  const steps = includePreferred ? ALL_STEPS : ALL_STEPS.filter((step) => step.path !== 'preferred-upgrade');

  // Renumber steps after filtering
  return steps.map((step, index) => ({
    ...step,
    stepNumber: index + 1,
  }));
};

// Default export for backwards compatibility (non-preferred flow)
export const OFFER_BUILDER_STEPS = getOfferBuilderSteps(false);

export const TOTAL_STEPS = OFFER_BUILDER_STEPS.length;

export const getCurrentStep = (pathname: string, includePreferred = false) => {
  const parts = pathname.split('/build-offer/');
  const relativePath = parts.length > 1 ? parts[1] : '';
  const steps = getOfferBuilderSteps(includePreferred);

  return steps.find((step) => step.path === relativePath || (step.path === '' && relativePath === '')) ?? steps[0];
};

export const isConfirmationPage = (pathname: string): boolean => {
  return pathname.includes('/build-offer/confirmation');
};
